import { type CommonSubmitSurveyAnswerRequest } from '@credit-web/services/product-journey-girar'
import { type TransformTypesToCamelCase } from '@credit-web/services/types'

import { type UseSurveysRequestVariables } from '../hooks/use-surveys-answers-create'

/**
 * POST:/api/web/v1/surveys
 */
export const commonSubmitSurveyAnswerRequest: TransformTypesToCamelCase<CommonSubmitSurveyAnswerRequest> = {
  surveyId: '<IdDaPesquisaRespondida>',
  surveyKey: '<KeyDaPesquisaRespondida>',
  questionAnswers: [
    {
      questionId: 'q1u2e3s4T5i6O7n8I9d0Q1u2e3s4t5i6',
      selectedOptionIds: ['opt2'],
      customTextAnswer: null
    },
    {
      questionId: 'q2a3b4c5D6e7F8g9H0i1J2k3l4m5n6o7',
      selectedOptionIds: ['opt8'],
      customTextAnswer: null
    },
    {
      questionId: 'q3x4y5z6A7b8C9d0E1f2G3h4i5j6k7l8',
      selectedOptionIds: ['opt12', 'opt14', 'opt16'],
      customTextAnswer: 'GostariaDeIntegraçãoComWhatsApp'
    }
  ]
}

export const commonSubmitSurveyAnswerRequestFull: UseSurveysRequestVariables = {
  answers: commonSubmitSurveyAnswerRequest,
  query: {
    Document: '12345678901'
  }
}
